import { render } from "./ProgramInfo.vue?vue&type=template&id=1ea2141f&scoped=true"
import script from "./ProgramInfo.vue?vue&type=script&lang=js"
export * from "./ProgramInfo.vue?vue&type=script&lang=js"

import "./ProgramInfo.vue?vue&type=style&index=0&id=1ea2141f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea2141f"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QImg,QBtn,QTooltip,QTabs,QTab,QTabPanels,QTabPanel,QSeparator,QSkeleton,QForm,QInput,QCardActions,QSpace});qInstall(script, 'directives', {ClosePopup});
